import { useMutation, useQueryClient } from '@tanstack/react-query';

import deleteGiveawayItem from 'Api/brief-live/deleteGiveawayItem';
import { useToast } from 'Store/toast';

const useDeleteGiveawayItem = ({ onSuccess } = {}) => {
  const queryClient = useQueryClient();
  const { onOpenToast } = useToast();

  return useMutation({
    mutationKey: ['delete-giveaway-item'],
    mutationFn: async ({ id }) => {
      return await deleteGiveawayItem(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['giveaway-by-id'] });
      onOpenToast({
        status: 'success',
        title: 'Success',
        description: 'Hadiah berhasil terhapus!',
        duration: 5,
        alwaysShow: false,
      });
      onSuccess?.();
    },
  });
};

export default useDeleteGiveawayItem;
